
import { chaloAPI, ChatMessage, ChatResponse } from './chaloAppAPI';

class ChatService {
  private conversations: Map<string, ChatMessage[]> = new Map();

  createConversation(conversationId: string): void {
    if (!this.conversations.has(conversationId)) {
      this.conversations.set(conversationId, []);
    }
  }

  addMessage(conversationId: string, message: ChatMessage): void {
    const conversation = this.conversations.get(conversationId) || [];
    conversation.push(message);
    this.conversations.set(conversationId, conversation);
  }

  getConversationHistory(conversationId: string): ChatMessage[] {
    return this.conversations.get(conversationId) || [];
  }

  async sendMessage(conversationId: string, userMessage: string): Promise<ChatResponse> {
    // Add user message to conversation
    const userChatMessage: ChatMessage = {
      role: 'user',
      content: userMessage,
      timestamp: new Date(),
    };
    
    this.addMessage(conversationId, userChatMessage);
    
    // Get conversation history
    const history = this.getConversationHistory(conversationId);
    
    // Send to API
    const response = await chaloAPI.sendChatMessage(userMessage, history);
    
    if (response.success) {
      // Add assistant response to conversation
      const assistantMessage: ChatMessage = {
        role: 'assistant',
        content: response.message,
        timestamp: new Date(),
      };
      
      this.addMessage(conversationId, assistantMessage);
    }
    
    return response;
  }

  clearConversation(conversationId: string): void {
    this.conversations.delete(conversationId);
  }

  async getAIHelp(query: string, context?: string): Promise<ChatResponse> {
    return await chaloAPI.getAIAssistance({
      query,
      context,
    });
  }
}

export const chatService = new ChatService();
